import "./paymentFAQ.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCreditCard,
  faLock,
  faMoneyBillWave,
  faUndo,
  faCheckCircle,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import paymentFAQ from "../../assets/images/payment-FAQ.svg"
import { useEffect } from "react";
import { Helmet } from "react-helmet";


export default function Payments() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Payment FAQ - Secure Payment Help</title>
        <meta
          name="description"
          content="Find answers to frequently asked questions about SHOP.CO payment methods, security, refunds, and billing issues."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/FAQ/payment/"
        />
      </Helmet>
      <div className="payments-container">
        <div className="payments-header">
          <div className="payments-text">
            <h1>Payments & Billing</h1>
            <p>
              Find answers to your questions about payment methods, refunds, and security.
            </p>
          </div>
          <img
            src={paymentFAQ}
            alt="Payments Illustration"
            className="payments-image"
          />
        </div>

        <div className="payments-grid">
          <div className="payments-card">
            <FontAwesomeIcon icon={faCreditCard} className="payments-icon" />
            <h3>Payment Methods</h3>
            <p>We accept Visa, MasterCard, PayPal, Apple Pay, and Cash on Delivery (COD) in selected areas.</p>
          </div>

          <div className="payments-card">
            <FontAwesomeIcon icon={faLock} className="payments-icon" />
            <h3>Secure Payments</h3>
            <p>All transactions are encrypted and processed through secure gateways to ensure your data stays safe.</p>
          </div>

          <div className="payments-card">
            <FontAwesomeIcon icon={faMoneyBillWave} className="payments-icon" />
            <h3>Payment Confirmation</h3>
            <p>You’ll receive a confirmation email with invoice and order details after successful payment.</p>
          </div>

          <div className="payments-card">
            <FontAwesomeIcon icon={faUndo} className="payments-icon" />
            <h3>Refund Policy</h3>
            <p>Refunds are processed within 3–5 business days after approval. May take longer to reflect in your account.</p>
          </div>

          <div className="payments-card">
            <FontAwesomeIcon icon={faCheckCircle} className="payments-icon" />
            <h3>Successful Transactions</h3>
            <p>Find transaction records under "My Orders" in your profile for quick access.</p>
          </div>

          <div className="payments-card">
            <FontAwesomeIcon icon={faExclamationTriangle} className="payments-icon" />
            <h3>Failed Transactions</h3>
            <p>If payment fails, try another method or contact support for help.</p>
          </div>
        </div>
      </div>
    </>
  );
}
